<template>
  <ion-page class="ai-product">
    <PageWhiteBackground
      title="AI写作"
      :background-color="{ background: '#F4FBFE' }"
      :router-type="'modal'"
      :external-source="externalSource"
      @router-back="routerBack"
    >
      <template #default>
        <div class="ai-product_content">
          <div v-if="!baseData.questionsAnswersResData" class="essay-box">
            <textarea
              v-model="baseData.question"
              maxlength="2000"
              placeholder="请输入待润色的短文，我能帮你修改语法用词，优化语言表达，提升写作文采"
              class="essay-box-text"
            >
            </textarea>
            <div class="essay-box-tools">
              <i
                v-show="baseData?.question?.length"
                class="iconfont icon-qingkong essay-box-tools_icon"
                @click="baseData.question = ''"
              ></i>
              <div class="essay-box-tools_text">{{ baseData?.question.length ?? 0 }}/2000</div>
            </div>
          </div>
          <div v-else class="generate-content">
            <TextEssay
              ref="textComponent2"
              generate-type="vocabulary"
              :as-raw-text="false"
              :inversion="false"
              :text="baseData.questionsAnswersResData.replace(/_\*\*|\*\*_|\*\*/g, '$')"
              :prop-word="baseData.question"
              @getMarkdownCallback="getMarkdownCallback"
              @clear="handleStop"
            />
          </div>
          <div class="bottom-group">
            <div
              v-if="!baseData.questionsAnswersResData"
              class="upload-button button-ripple"
              @click="openImagePicker"
            >
              <img src="@/assets/ai/icon-ai-write-1.png" />
              上传图片
              <input
                id="file-input"
                style="display: none"
                type="file"
                accept=".jpg,.jpeg,.png,.webp,.svg,.bmp"
                @change="handleFileInputChange"
              />
            </div>
            <div
              v-if="!baseData.questionsAnswersResData"
              class="essay-button button-ripple"
              @click="postChatMessage"
            >
              <i v-if="isLoading" class="iconfont icon-tingzhi essay-button_icon"></i>
              <img v-if="!isLoading" src="@/assets/ai/icon-ai-write-2.png" />
              {{ isLoading ? "停止生成" : "一键校对" }}
            </div>
          </div>
        </div>
      </template>
    </PageWhiteBackground>
    <aiLoading ref="aiLoadingRef" />
  </ion-page>
</template>

<script setup lang="ts">
import { alertController, IonInput, IonPage, modalController } from "@ionic/vue";

import { useRoute, useRouter } from "vue-router";
import { defineProps, nextTick, onMounted, reactive, ref, watch } from "vue";
import tools from "@/js/tools";
import requestApi from "@/js/http";
import http from "@/js/http";
import { BRAND_IMAGES } from "@/js/brandImages";
import WinRecord from "@/js/Record";
import store from "@/js/store";
import PageWhiteBackground from "@/components/PageWhiteBackground.vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useStorage, useToggle } from "@vueuse/core";
import TextEssay from "@/views/AIGenerate/components/TextEssay.vue";
import SafeWord from "@/components/SafeWord.vue";
import aiLoading from "@/components/aiLoading.vue";
import OcrScanLoading from "@/views/AIGenerate/components/OcrScanLoading.vue";
import ScanResult from "@/views/AIGenerate/components/ScanResult.vue";
import { aiUsageLimit } from "@/js/aiUsageLimit";

const server_url = `${http.aiUrl}/gpt/sseChatPrompt`;
const audio_url = "http://47.254.121.216:6039/api/speechMsg";
const audio_file_url = "http://47.254.121.216:6039/";
const authorization =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxNzM3NjY0OTMyNDI2MTU4MDgxIiwicm5TdHIiOiJOMlFWMnNDdzh2TmdQSllVNFRheUlFeWdyVUtHb0lBZCIsInRlbmFudElkIjoiMDAwMDAiLCJ1c2VySWQiOjE3Mzc2NjQ5MzI0MjYxNTgwODF9.YExs672d7euNs27Xsl5aum5433AJEMYum9fpOYdC3zA";

interface Props {
  question?: string;
}

const userInfo = useStorage("userinfo", {});
const record = ref<any>(null);
const router = useRouter();
const route = useRoute();
const params = ref<any>();
const aiLoadingRef = ref();
const textComponent2 = ref<any>();
const markdownRef = ref<any>();
const props = defineProps<Props>();
const brandImages = BRAND_IMAGES;
const baseData = reactive<any>({
  title: "",
  // 选择题
  testPaperData: [],
  // 问答题
  questionsAndAnswersData: {},
  questionsAnswersResData: "",
  // 完形填空
  clozeData: {},
  question: "",
  aiType: "",
  audioUrl: "",
  audioPlayState: true,
  audioFile: null,
  markdownDom: null,
  conversationId: "", // chatGpt会话id
});

const httpController = ref<any>();
const [isLoading, changeIsloading] = useToggle();
const externalSource = ref(false);

/**
 * 【AI词典大全】 OPENAI_PROMPT_WORDLIST
 * 【AI语法分析】OPENAI_PROMPT_ANALYZEGRAMAR
 * 【AI校对文章】 OPENAI_PROMPT_PROOFREAD_ARTICLE
 * 【AI短文】（1）OPENAI_PROMPT_READPASSAGE （2） OPENAI_PROMPT_READPASSAGE_V1 新
 * 【AI对话练习】 OPENAI_PROMPT_VOICE_CONVERSATION
 * 【AI阅读理解】 OPENAI_PROMPT_EXAMPAPER_QA
 * 【AI短句训练】 OPENAI_PROMPT_SHORT_SENTENCE
 */

async function routerBack() {
  nextTick(() => {
    baseData.questionsAnswersResData = "";
    httpController.value?.abort("终止请求"); // 终止请求
  });
  if (props.question) {
    await modalController.dismiss("cancel");
  } else {
    router.go(-1);
  }
}

// 请求gpt
async function postChatMessage() {
  if (isLoading.value) {
    handleStop();
    return;
  }
  if (!baseData.question) {
    await openMsgToast("请输入内容");
    return;
  }

  if (baseData.question.match(/[\u4e00-\u9fa5]/g)) {
    await openMsgToast("不允许输入中文字符");
    return;
  }

  /* eslint-disable */
  // 限制所有特殊字符出现3次以上
  if (
    baseData.question.match(
      /[-!@#$%^&*()<>?:"{}|`,.;'~！、￥……”“‘’；：。，、】【=——+￡￠\/\\[\]]{4,}/g
    )
  ) {
    await openMsgToast(`存在非法字符，请仔细检查`);
    return;
  }

  baseData.questionsAnswersResData = "";
  httpController.value?.abort("终止请求");

  const signal = getHttpControllerSignal();
  changeIsloading(true);
  await nextTick(() => {
    aiLoadingRef.value && aiLoadingRef.value.open();
  });
  const serverKey = "OPENAI_PROMPT_PROOFREAD_ARTICLE-0507-1";
  const requestParams = {
    userSubmitId: userInfo.value?.schoolId,
    userKey: "",
    serverKey: serverKey,
    conversationId: new Date().getTime(),
    prompt: baseData.question || "", // baseData.question
    promptParameter: { grade: "", wordCount: "" },
    options: {},
    usingContext: true,
    topP: 1,
    contentNumber: 10,
    filterSensitive: true,
  };
  try {
    const usageLimit = await aiUsageLimit(serverKey);
    if (usageLimit) {
      http.get("/Ai/getAiToken").then(async (res) => {
        if (res.data.code === 200) {
          const userKey = res.data.data;
          const resData = await fetch(`${http.aiUrl}/gpt/sseChatPrompt`, {
            method: "POST",
            body: JSON.stringify({ ...requestParams, userKey: userKey }),
            headers: { "content-type": "application/json" },
            signal,
          });
          await analysisStreamData(resData);
        } else {
          aiLoadingRef.value && aiLoadingRef.value.close();
        }
      });
    } else {
      changeIsloading(false);
    }
  } catch (e) {
    changeIsloading(false);
    aiLoadingRef.value && aiLoadingRef.value.close();
  }
  // textComponent.value.modifyWordStylePlugin(baseData.question) // 根据输入的单词动态修改markdown样式
}

// 解析 stream 流文件
async function analysisStreamData(resData: any) {
  const reader = (resData.body?.getReader() as any) || {};
  const decoder = new TextDecoder();
  const flag = true;
  await handleElseResStrData(flag, reader, decoder);
}

function getMarkdownCallback(callback: any) {
  callback(baseData.question);
}

async function handleElseResStrData(flag: any, reader: any, decoder: any) {
  while (flag) {
    let { done, value } = (await reader?.read()) as any;
    if (done) {
      changeIsloading(false);
      if (
        baseData.questionsAnswersResData.includes("code") &&
        baseData.questionsAnswersResData.includes("5001")
      ) {
        const modal = await modalController.create({
          component: SafeWord,
          componentProps: {
            msg: JSON.parse(baseData.questionsAnswersResData).msg,
          },
          cssClass: "common_center_modal_container_transparent",
        });
        await modal.present();
        await modal.dismiss();
        baseData.questionsAnswersResData = "";
      }
      break;
    }
    const txt = decoder.decode(value);
    baseData.questionsAnswersResData += txt;
    aiLoadingRef.value && aiLoadingRef.value.close();
  }
}

// 根据返回接口生成音频文件并播放
function getAudioUrl(signal: any) {
  if (baseData.audioFile) {
    baseData.audioFile.pause();
    baseData.audioFile = null;
  }
  baseData.audioUrl = "";
  const conversationParams = {
    msgId: new Date().getTime(),
    msg: baseData.question,
    signal: signal,
  };
  requestApi.post(audio_url, conversationParams).then((res) => {
    if (res?.data?.code === 200) {
      baseData.audioUrl = audio_file_url + res.data.msg || "";
      baseData.audioFile = new Audio(baseData.audioUrl) as any;

      // 获取音频文件立即播放
      if (baseData.audioFile) {
        baseData.audioFile.play();
        baseData.audioPlayState = false;
      }
      handleAudioEndEvent();
    }
  });
}

// 点击播放 or 暂停播放
async function audioPlay() {
  if (baseData.audioFile) {
    // load() 重新加载
    // 播放
    if (baseData.audioPlayState) {
      baseData.audioFile.play();
      baseData.audioPlayState = false;
    } else {
      // 停止播放
      baseData.audioFile.pause();
      baseData.audioPlayState = true;
    }
  } else {
    alertPopOverDialog("暂无音频文件，请稍等...");
  }
}

// 监听音频文件播放结束
function handleAudioEndEvent() {
  if (baseData.audioFile) {
    baseData.audioFile.addEventListener("ended", () => {
      baseData.audioPlayState = true;
    });
  }
}

// 弹窗组件
async function alertPopOverDialog(msg: string) {
  const alert = await alertController.create({
    subHeader: msg,
    buttons: [],
  });
  await alert.present();
}

// 下拉刷新页面
function doRefresh(RefreshAnimationEvent: any) {
  tools.closeRefreshAnimation(RefreshAnimationEvent, 200);
  initPageInfo();
}

// 点击页面返回按钮 返回首页
function navigateBackHomePage() {
  router.back();
  // router.push('/TeacherIndex')
  // 音频文件停止播放
  if (baseData.audioFile) {
    baseData.audioFile.pause();
    baseData.audioFile = null;
    baseData.audioPlayState = true;
  }

  nextTick(() => {
    baseData.questionsAnswersResData = "";
    httpController.value?.abort("终止请求"); // 终止请求
  });
}

function getHttpControllerSignal() {
  httpController.value = new AbortController();
  const { signal } = httpController.value;
  return signal;
}

function getAudioGptAnswer(rData: string) {
  const signal = getHttpControllerSignal();
  baseData.question = rData ? rData?.data : "";
  // baseData.question = 'What day is it today'
  getAudioUrl(signal);
}

function initPageInfo() {
  baseData.questionsAnswersResData = "";
  baseData.conversationId = new Date().getTime();
  switch (params.value) {
    case "dictionary":
      baseData.title = "AI词典";
      baseData.aiType = "OPENAI_PROMPT_WORDLIST";
      break;
    case "grammar":
      baseData.title = "AI语法";
      baseData.aiType = "OPENAI_PROMPT_PROOFREAD_ARTICLE"; // 校对文章
      // baseData.aiType = 'OPENAI_PROMPT_ANALYZEGRAMAR'
      break;
    case "articles":
      baseData.title = "AI语法";
      baseData.aiType = "OPENAI_PROMPT_ANALYZEGRAMAR"; // 语法分析
      // baseData.aiType = 'OPENAI_PROMPT_PROOFREAD_ARTICLE'
      break;
    case "shortArticle":
      baseData.title = "AI短文";
      // baseData.aiType = 'OPENAI_PROMPT_READPASSAGE'
      baseData.aiType = "OPENAI_PROMPT_READPASSAGE_V1";
      break;
    case "dialogue":
      baseData.title = "AI听力";
      baseData.aiType = "OPENAI_PROMPT_LISTENINGPRACTICE";
      break;
    case "comprehension":
      baseData.title = "AI智阅";
      // baseData.aiType = 'OPENAI_PROMPT_EXAMPAPER_QA' // App 没有选择题 根据单词或句子拓展内容
      // baseData.aiType = 'OPENAI_PROMPT_EXAMPAPER_QA_PC' // PC 根据学过的单词生成短文和问题
      baseData.aiType = "OPENAI_PROMPT_EXAMPAPER_QA_APP"; // PC 根据学过的单词生成短文和问题
      break;
    case "sentenceTraining":
      baseData.title = "AI短句训练";
      baseData.aiType = "OPENAI_PROMPT_SHORT_SENTENCE";
      break;
    case "voiceConversation":
      baseData.title = "AI听口";
      baseData.aiType = "OPENAI_PROMPT_VOICE_CONVERSATION";
      break;
    default:
      return;
  }
}

function initRecord() {
  const isMobile = store.isMobile();

  // 判断是否是手机端
  if (isMobile) {
    // record.value = new Record() // 手机 html5 录音
    record.value = new WinRecord(audio_file_url);
  } else {
    record.value = new WinRecord(audio_file_url);
  }
}

function handleStop() {
  httpController.value?.abort();
  changeIsloading(false);
  aiLoadingRef.value.close();
  baseData.questionsAnswersResData = "";
}

function handleWindowLocationParamsValue() {
  const pathname = window.location.pathname;
  const regex = /^\/ai-generate\/(.*)$/;
  const match = pathname.match(regex);
  if (match) {
    params.value = match[1];
  }
}

async function handleFileInputChange(e: any) {
  let that = this;
  const file = e.target.files[0];

  if (!file) {
    return;
  }

  if (!/image\/+/g.test(file.type)) {
    // 其他格式文件
    openMsgToast("请上传图片文件!");
    return;
  }
  const windowURL = window.URL || window.webkitURL;
  const src = windowURL.createObjectURL(file);

  //识别加载动画
  const model1 = await modalController.create({
    component: OcrScanLoading,
    componentProps: { imgSrc: src },
    cssClass: "modal_controller_class",
  });
  model1.present();

  let formData = new FormData();
  formData.append("file", file);
  http.post("/ocr/ocrCommMultiLanguage", formData).then(async (res) => {
    if (res.data.success) {
      //打开识别结果
      const model2 = await modalController.create({
        component: ScanResult,
        componentProps: { result: res.data.data },
        cssClass: "modal_controller_class",
      });
      model1.dismiss();
      model2.present();
      model2.onDidDismiss().then((res) => {
        baseData.question = res.data ? res.data : "";
        windowURL.revokeObjectURL(src);
      });
    }
  });
}

function openImagePicker() {
  if (isLoading.value) {
    openMsgToast("ai生成中，不能上传图片");
    return;
  }
  const upload_id = document.getElementById("file-input");
  upload_id.value = null;
  upload_id?.click();
}

watch(
  () => props.question,
  () => {
    if (props.question) {
      baseData.question = props.question;
      postChatMessage();
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (route.query && route.query.source) {
    externalSource.value = route.query.source === "external";
  }
  handleWindowLocationParamsValue();
  initPageInfo();
  initRecord();
  handleAudioEndEvent();
  baseData.markdownDom = document.querySelector(".markdown-body2") as any;
});
</script>

<style scoped lang="less">
@import "@/styles/github-markdown.less";

.ai-product {
  width: 100%;
  height: 100%;

  &_content {
    width: 100%;
    height: 100%;
  }

  .essay-box {
    width: 100%;
    height: calc(100% - 6.2rem);
    background: linear-gradient(90deg, #00acff 0%, #3effb9 100%);
    border-radius: 0.8rem;
    position: relative;

    &-text {
      background: #ffffff;
      width: calc(100% - 0.4rem);
      height: calc(100% - 0.4rem);
      margin: 0.2rem;
      border-radius: 0.7rem;
      border: none;
      outline: none;
      padding: 0.8rem;
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 400;
      color: #262626;
      resize: none;

      &::placeholder {
        color: #868f9e;
      }

      &:focus-within {
        outline: none;
      }
    }

    &-tools {
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 0.8rem;

      &_icon {
        font-size: 1rem;
        color: #262626;
        margin-right: 0.5rem;
      }

      &_text {
        color: #868f9e;
      }
    }
  }

  .bottom-group {
    margin-top: 2.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .upload-button {
    width: 48%;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(90deg, #a1f9ff 0%, #bdfbff 100%);
    border-radius: 2rem;
    color: #374067;
    font-size: 1.2rem;

    &_icon {
      font-size: 1.5rem;
      margin-right: 0.5rem;
    }

    img {
      width: 1.7rem;
      height: 1.7rem;
      margin-right: 0.5rem;
    }
  }

  .essay-button {
    width: 48%;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(90deg, #b8f7e4 0%, #d2ffef 100%);
    border-radius: 2rem;
    color: #0b6c4f;
    font-size: 1.2rem;

    &_icon {
      font-size: 1.5rem;
      margin-right: 0.5rem;
    }

    img {
      width: 1.8rem;
      height: 1.8rem;
      margin-right: 0.5rem;
    }
  }

  .generate-content {
    width: 100%;
    height: 100%;
  }
}

.item-right span {
  display: inline-block;
  width: 25%;
}

p {
  margin: 3vw;
  background: linear-gradient(90deg, #dceaf6 0%, #f6f7f9 100%);
}

.false-red {
  color: red;
}

.success-green {
  color: #56ef56;
}

.ta-center {
  text-align: center;
}

ion-input {
  margin: 0 3vw;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.margin-03 {
  margin: 0 3vw;
}

.strong-red {
  color: red;
}
</style>
